import { Form } from '@ui';
import styled from 'styled-components';

export const ConfirmModalSC = styled.div`
  .alert-margins {
    margin: 60px auto;
    max-width: 450px;
  }
`;

export const FormSC = styled(Form)`
  .ui-textfield {
    width: 100%;
  }
` as typeof Form;
